<template>
  <div class="fragment">
    <span class="fragment__title">{{ title }}</span>
    <slot />
    <button
      class="fragment__remove"
      type="button"
      v-on:click="$emit('remove')"
    >Убрать</button>
  </div>
</template>
<script>
/**
 * @description Фрагмент формы создания шаблона СМС.
 * @type {Vue}
 */
export default {
  name: 'NotificationPlanFragment',
  props: {
    title: {
      required: true,
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.fragment {
  border: 1px solid var(--border-color);
  border-radius: var(--input-border-radius);
  padding: .5rem;
  position: relative;
  &__remove {
    @include buttons.btn-transparent-remove(1rem);
    position: absolute;
    right: .5rem;
  }
  &__title {
    color: var(--unfocus-color);
    display: block;
    font-size: .75rem;
  }
}
</style>
